var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.auction)?_c('b-table',{attrs:{"responsive":"","hover":"","head-variant":"light","items":_vm.auction.price_log,"fields":_vm.fields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }